$(document).on('click', '.js-select-option', function(e) {
  e.preventDefault();
  var $option = $(this);
  var $select = $option.parents('.js-custom-select');
  var inputName = $select.data("name");

  var $form = $select.parents('form');
  var $input = $form.find('input[name="' + inputName + '"]');
  $input.val($option.data('value'));
  $form.submit();
});

$(document).ready(function() {
  $('.js-custom-select').each(function() {
    var $select = $(this);
    var $form = $select.parents('form');
    var $input = $form.find('input[name="' + $select.data('name') + '"]');
    var $current = $select.find(".js-custom-select-value");
    $select.find('.js-select-option').each(function() {
      var $option = $(this);
      if ( $option.data('value') == $input.val() ) {
        $current.html($option.html());
      }
    });
  });
});
